import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {LocalisationService} from 'src/app/modules/shared/services/localisation.service';
import * as moment from 'moment';
import {UsersService} from '../../../../shared/services/users.service';
import {Languages} from '../../../../shared/enums/languages';
import {MealsComponent} from '../../meals/meals.component';
import {NotificationsService} from '../../../../shared/services/notification.service';
import {DiaryRecipeViewModel} from '../../../../shared/viewModels/diaryRecipe.viewModel';
import {DiaryService} from '../../../../shared/services/diary.service';
import {PricingService} from '../../../../pricing/services/pricing.service';
import {AppLoadingEventsEmitter} from '../../../../shared/events/loading.events';

@Component({
    selector: 'app-copy-diary-recipes-advanced',
    templateUrl: './copy-diary-recipes-advanced.component.html',
    styleUrls: ['./copy-diary-recipes-advanced.component.scss']
})
export class CopyDiaryRecipesAdvancedComponent implements OnInit, AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    diaryRecipe: DiaryRecipeViewModel;
    mealsComponent: MealsComponent;

    dates = [];
    selectedDates = [];

    fromDate: Date = new Date((new Date()).setDate((new Date()).getDate() - (new Date()).getDay() + (((new Date()).getDay() === 0 ? -6 : 1)) + 7));
    toDate: Date = new Date((new Date()).setDate((new Date()).getDate() - (new Date()).getDay() + (((new Date()).getDay() === 0 ? -6 : 1)) + 13));

    settings = {
        bigBanner: false,
        timePicker: false,
        format: 'dd.MM.yyyy',
        defaultOpen: false,
        closeOnSelect: true
    };

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly usersService: UsersService,
        private readonly localisationService: LocalisationService,
        private readonly diaryService: DiaryService,
        private readonly pricingService: PricingService,
        private readonly notificationService: NotificationsService,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
    ) {
    }

    ngOnInit() {
        this.init();
    }

    onStartDateChange(event) {
        const fromDate = moment(this.fromDate).format('YYYY-MM-DD');
        const toDate = moment(this.toDate).format('YYYY-MM-DD');

        if (fromDate > toDate) {
            this.toDate = this.fromDate;
        }
    }

    onToDateChange(event) {
        const fromDate = moment(this.fromDate).format('YYYY-MM-DD');
        const toDate = moment(this.toDate).format('YYYY-MM-DD');

        if (fromDate > toDate) {
            this.fromDate = this.toDate;
        }
    }

    private init() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        const interval = setInterval(() => {
            if (this.mealsComponent) {
                clearInterval(interval);

                for (let i = -7; i <= 6; i++) {
                    const date = moment(this.mealsComponent.dateObj).add(i, 'days');
                    let week_name = date.format('dddd');

                    if (this.localisationService.getLanguage() === Languages.Bulgarian) {
                        const bg_week_names = {
                            'Monday': 'Понеделник',
                            'Tuesday': 'Вторник',
                            'Wednesday': 'Сряда',
                            'Thursday': 'Четвртък',
                            'Friday': 'Петък',
                            'Saturday': 'Събота',
                            'Sunday': 'Неделя',
                        };
                        week_name = bg_week_names[week_name];
                    }

                    this.dates.push({
                        'date': date.format('DD.MM.YYYY'),
                        'week_name': week_name
                    });
                }

                this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            }
        }, 100);
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    markDayAsSelected(date) {
        if (this.selectedDates.includes(date)) {
            this.selectedDates = this.selectedDates.filter(selectedDate => selectedDate !== date);
        } else {
            this.selectedDates.push(date);
        }
    }

    copyRecipe() {
        if (this.selectedDates.length <= 0) {
            this.notificationService.error(this.localisationService.localise('copy_recipe_fill_all_required_fields'));
            return;
        }

        this.diaryService
            .copyAllDiaryRecipesToInterval(
                moment(this.fromDate).format('YYYY-MM-DD'),
                moment(this.toDate).format('YYYY-MM-DD'),
                this.selectedDates
            )
            .subscribe(() => {
                this.notificationService.success(this.localisationService.localise('copy_recipe_copied_success'));
                this.bsModalRef.hide();
                this.mealsComponent.init().subscribe();
            }, () => {
                this.notificationService.error(this.localisationService.localise('copy_recipe_failed'));
            });
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    private getMonday(date) {
        return new Date(date.setDate((date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1))));
    }

    isIOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }
}
